/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/interactive-supports-focus */

import React from 'react';
import PropTypes from 'prop-types';
import { accountPropTypes, payeePropTypes } from './propTypes';
import PayeeList from '../PayeeList';

const FromToPayeeSelector = ({
	fromAccount,
	toPayees,
	content,
	onPayeeListContinue,
	toAccounts,
	showAccounts,
	showBeneficiaries,
	canAddMultiplePayments,
	toAccount,
	searchMinimumLength,
	handleCancelPayeeSelect,
	handleDisplayFullwidth,
	paymentLimit,
	currentPaymentCount,
	showAddPayeeButton,
	selectedPaymentId,
	isLargeCustomerView,
	setLCVAccountsInAccountList,
	setPayees,
	removePayee,
	paymentMode,
}) => {
	const { addPayeeButtonTitle, noSearchResultMessage, paymentsLimitMessage, payeeSingularCountMessage } = content;

	return (
		<PayeeList
			addPayeeButtonTitle={addPayeeButtonTitle}
			onContinue={onPayeeListContinue}
			noSearchResultMessage={noSearchResultMessage}
			accounts={toAccounts}
			payees={toPayees}
			showAccounts={showAccounts}
			showBeneficiaries={showBeneficiaries}
			canAddMultiplePayments={canAddMultiplePayments}
			showAddPayeeButton={showAddPayeeButton}
			paymentsLimitMessage={paymentsLimitMessage}
			searchMinimumLength={searchMinimumLength}
			payeeSingularCountMessage={payeeSingularCountMessage}
			currentPaymentCount={currentPaymentCount}
			paymentLimit={paymentLimit}
			editPaymentPayee={toAccount}
			fromAccountId={fromAccount}
			selectedPaymentId={selectedPaymentId}
			isLargeCustomerView={isLargeCustomerView}
			setLCVAccountsInAccountList={setLCVAccountsInAccountList}
			handleCancelPayeeSelect={handleCancelPayeeSelect}
			handleDisplayFullwidth={handleDisplayFullwidth}
			setPayees={setPayees}
			removePayee={removePayee}
			paymentMode={paymentMode}
		/>
	);
};

FromToPayeeSelector.defaultProps = {
	toAccounts: [],
	showAddPayeeButton: true,
	currentPaymentCount: 0,
	setLCVAccountsInAccountList: () => {},
};

FromToPayeeSelector.propTypes = {
	fromAccount: PropTypes.string.isRequired,
	toAccounts: PropTypes.arrayOf(PropTypes.shape(accountPropTypes)),
	toAccount: PropTypes.string,
	selectedPaymentId: PropTypes.string,
	toPayees: PropTypes.arrayOf(PropTypes.shape(payeePropTypes)),
	onPayeeListContinue: PropTypes.func.isRequired,
	canAddMultiplePayments: PropTypes.bool,
	showAccounts: PropTypes.bool,
	showBeneficiaries: PropTypes.bool,
	searchMinimumLength: PropTypes.number.isRequired,
	content: PropTypes.shape({
		addPayeeButtonTitle: PropTypes.string.isRequired,
		noSearchResultMessage: PropTypes.string.isRequired,
		paymentsLimitMessage: PropTypes.string.isRequired,
		payeeSingularCountMessage: PropTypes.string.isRequired,
	}),
	handleCancelPayeeSelect: PropTypes.func.isRequired,
	handleDisplayFullwidth: PropTypes.func,
	paymentLimit: PropTypes.number.isRequired,
	currentPaymentCount: PropTypes.number,
	showAddPayeeButton: PropTypes.bool,
	isLargeCustomerView: PropTypes.bool.isRequired,
	setLCVAccountsInAccountList: PropTypes.func,
	setPayees: PropTypes.func.isRequired,
	removePayee: PropTypes.func.isRequired,
	paymentMode: PropTypes.string,
};
export default FromToPayeeSelector;
